import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '../../../../components/ui/input';
import { setFilters } from '../../../../store/uploads/actions';
import IconButton from '../../../../components/IconButton';
import FiltersModal from './FiltersModal';
import { FunnelIcon, PlusIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { useUploadHistoryContext } from '../../../../contexts/UploadHistoryContext';
import { Button } from '../../../../components/ui/button';
import constants from '../../../../commonUtils/constants';
import { useNavigate } from 'react-router-dom';
import { hasPermission } from '../../../../commonUtils/permission.helper';

const FiltersSection = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const doNotShowBadgeForKeys = ["keyword", "pending", "startDate", "endDate"];
    const { filters } = useSelector((state) => state.Uploads);
    const [openFilterModal, setOpenFilterModal] = useState(false);
    
    // const { pageLoadData } = useSelector((state) => state.Uploads);
    const { table, toggleShowPending, loadUploadLogs } = useUploadHistoryContext();

    const closeModal = () => {
        setOpenFilterModal(false);
    }
    
    const handleFilterChange = (key, value) => {
        // console.log("key", key)
        if(key==="startDate" || key==="endDate") {
            // console.log("value", value)
            // console.log("typeof value", typeof value)
            // if (value instanceof Date) {
            //     value = format(value, 'yyyy-MM-dd'); // Format the date to a string
            // }
        }
        if(value === "0") value = ""
        dispatch(setFilters({ ...filters, [key]: value }));
    };

    const clearFilters = () => {
        dispatch(setFilters(constants.upload.filtersInitialState));
        loadUploadLogs();
    };

    const applyFilters = (visibilityState) => {
        table.getAllColumns().forEach((column) => {
            if (column.getCanHide() && visibilityState.hasOwnProperty(column.id)) {
                column.toggleVisibility(visibilityState[column.id]);
            }
        });
        loadUploadLogs();
        // dispatch(setFilters(constants.upload.filtersInitialState));
        setOpenFilterModal(false);
    };


    return (
        <>
            <div className="flex justify-between items-end gap-2 mb-4 hidden md:flex">
                <div className='flex-none'>
                    <h6 className="font-bold text-sm mb-2">Filters</h6>
                    <div className="w-[200px]">
                        <Input
                            required
                            id="keyword"
                            name="keyword"
                            type="text"
                            autoComplete="keyword"
                            placeholder="Search"
                            value={filters.keyword || ''}
                            onChange={(e) => handleFilterChange('keyword', e.target.value)}
                            className="bg-white dark:bg-secondary focus-visible:ring-primary-foreground"
                        />
                    </div>
                </div>
                <div className='flex flex-grow gap-2 items-end'>
                    <>
                        {/* {Object.entries(filters)
                        .filter(([key, value]) => value && !doNotShowBadgeForKeys.includes(key))
                        .map(([key, value]) => (
                            <Badge key={key} className="flex flex-col items-start hover:bg-primary hover:text-white">
                                <small>{camelToSentenceCase(key)}</small> 
                                <p className='text-md'>
                                    {isValidObjectId(value) ? 
                                        getValueForObjId(pageLoadData[getPageLoadDataKey(key)], value) : value
                                    }
                                </p>
                            </Badge>
                        ))} */}
                        <div className='col-span-1'>
                            <IconButton variant="action_muted" size="icon" Icon={XMarkIcon} onClick={clearFilters} />
                        </div>
                    </>
                </div>
                <div className='flex flex-col justify-between items-end gap-4'>
                    {hasPermission('upload.upload_files') && (
                        <Button variant="border_outline" onClick={() => navigate('/upload-files')}>
                            <PlusIcon className='w-4 h-4 mr-2' /> New Upload
                        </Button>
                    )}
                    <div className='flex justify-between items-end gap-2'>
                        <Button variant={filters.pending ? "border_outline" : "outline"} onClick={toggleShowPending}>Pending Approvals</Button>
                        <IconButton
                            variant="default"
                            size="icon"
                            Icon={FunnelIcon}
                            rounded="default"
                            onClick={e => setOpenFilterModal(true)}
                        />
                    </div>
                </div>
            </div>
            <div className="flex flex-col justify-between gap-4 mb-4 md:hidden">
                <div className='flex justify-end items-end gap-2'>
                    <Button variant={filters.pending ? "border_outline" : "outline"} onClick={toggleShowPending}>Pending Approvals</Button>
                    <IconButton
                        variant="default"
                        size="icon"
                        Icon={FunnelIcon}
                        rounded="default"
                        onClick={e => setOpenFilterModal(true)}
                    />
                </div>
                <div>
                    <div className='flex-none'>
                        <div className='flex justify-between'>
                            <h6 className="font-bold text-sm mb-2">Filters</h6>
                            <IconButton variant="action_muted" size="icon-sm" className="p-1 mb-1" Icon={XMarkIcon} onClick={clearFilters} />
                        </div>
                        <div className="w-full">
                            <Input
                                required
                                id="keyword"
                                name="keyword"
                                type="text"
                                autoComplete="keyword"
                                placeholder="Search"
                                value={filters.keyword || ''}
                                onChange={(e) => handleFilterChange('keyword', e.target.value)}
                                className="bg-white dark:bg-secondary focus-visible:ring-primary-foreground"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <FiltersModal
                openFilterModal={openFilterModal}
                closeModal={closeModal}
                clearFilters={clearFilters}
                applyFilters={applyFilters}
                handleFilterChange={handleFilterChange}
            />
        </>
    );
};

export default FiltersSection;
